module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "zbxxd_main_wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('div', {
    staticClass: "lable"
  }, [_vm._v("当前位置:")]), _vm._v(" "), _c('div', {
    staticClass: "breadcrumb_item"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.returnPre(0)
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.returnPre(1)
      }
    }
  }, [_c('span', [_vm._v(">")]), _vm._v(_vm._s(_vm.mtname))]), _vm._v(" "), (_vm.model.zbxxClass) ? _c('div', [_c('span', [_vm._v(">")]), _vm._v(_vm._s(_vm.model.zbxxClass.sys_dname))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.model.sys_title)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-right": "4px"
    }
  }, [_vm._v("日期: " + _vm._s(_vm.model.sys_idate))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("阅读数: " + _vm._s(_vm.model.sys_click == 0 ? 1 : _vm.model.sys_click + 1))])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.model.sys_content)
    }
  }), _vm._v(" "), (_vm.model.sys_author !== null && _vm.model.sys_author !== 'CGPT') ? _c('div', {
    staticStyle: {
      "text-align": "right",
      "font-size": "16px"
    }
  }, [_c('p', [_vm._v("广东元正招标采购有限公司")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.model.sys_idate))])]) : _vm._e(), _vm._v(" "), (_vm.model.zbxxfj) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [(_vm.model.zbxxfj.length > 0) ? _c('div', [_vm._v("附件信息：")]) : _vm._e(), _vm._v(" "), (_vm.model.zbxxfj.length > 0) ? _c('div', [(+_vm.model.zbxxfj[0].zbxxfjtype === 1) ? _c('div', _vm._l((_vm.model.zbxxfj), function(i) {
    return _c('div', {
      key: i.id
    }, [_c('div', {
      staticStyle: {
        "color": "#2f74ff",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.downFile(i.zbxxfjurl)
        }
      }
    }, [_vm._v(_vm._s(i.zbxxfjname))])])
  }), 0) : _c('div', _vm._l((_vm.model.zbxxfj), function(i) {
    return _c('div', {
      key: i.id
    }, [_c('a', {
      staticStyle: {
        "color": "#2f74ff",
        "cursor": "pointer"
      },
      attrs: {
        "href": i.zbxxfjurl,
        "target": "＂_black＂"
      }
    }, [_vm._v(_vm._s(i.zbxxfjname))])])
  }), 0)]) : _vm._e()]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-bf726494!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/web/ZbxxDetail.vue
// module id = 307
// module chunks = 0